import { render } from "./Tal_helpMemberPop.vue?vue&type=template&id=d5412ba2"
const script = {}

import "./Tal_helpMemberPop.vue?vue&type=style&index=0&id=d5412ba2&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__